module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/photography-darkmode.809c2da5.png";